<div id="myModal" class="p-modal">
  <div class="p-modal-container">
    <div class="p-modal-header ps-4">
      <h6 class="p-modal-header__title">{{ title }}</h6>
      <i-feather
        *ngIf="canClose"
        class="p-modal-header__close"
        name="x"
        (click)="closeModal()"
      ></i-feather>
    </div>
    <div class="p-modal-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
